<template>
 <div class="faq">
  <div v-for="(history, index) in histories" :key="index">
    <input type="checkbox" :id="index" name="q"  class="questions">
    <div class="plus">+</div>
    <label :for="index" class="question">
      {{ normalizePaymentMethod(history.payment.paymentMethod)  }} payment ( ***{{ history.payment.phoneNumber ? history.payment.phoneNumber.substring(7) : history.payment.last4 }} ) {{history.total}} {{ history.currency}}
      <span>{{ new Date(history.created).toLocaleDateString('fr-FR') }}</span>
    </label>
    <div class="answers">
    <table class="table table-hover">
    <thead>
      <tr>
        <th>Product</th>
        <th>Ref</th>
        <th>Price</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in history.items" :key="index">
        <td>{{ item.product_name}}</td>
        <td>{{item.refId || 'N/A'}}</td>
        <td>{{item.currency.toUpperCase()}} {{item.price}}</td>
        <td>
          <span v-if="item.refId">Payment successful</span>
          <span v-if="!item.refId">
            Payment failed
            <label v-if="item.result" style="color: red; font-style: italic;"> ({{item.result}})</label>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
    </div>
  </div>

  <div id="loading" style="text-align: center; margin-bottom: 50px;" class="panel-body row-fluid" v-if="loading">
    <svg class="spinner" width="45px" height="45px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
    </svg>
  </div>
    <div class="alert alert-info fade in" style="text-align:center;" v-if="noHistory">
      <!-- <i aria-hidden="true" style="font-size:23px; float:left;" class="fa fa-exclamation-triangle"></i> -->
      <p style="font-size:16px;">No data found.<br>The purchases you made will be displayed here</p>
    </div>
    <div style="float: right; margin-top: 24px" v-if="!loading && !noHistory">
      <label style="font-style: italic;">
        Page {{currentPage}} of {{numberOfPages}}
      </label>
    </div>
    <div class="btn-group pagination" role="group" v-if="!loading && !noHistory">
      <button
        type="button"
        class="btn btn-default"
        @click="setCurrentPage('DEC')"
        :disabled="currentPage === 1"
      >
        Prev
      </button>
      <button
        type="button"
        class="btn btn-default"
        @click="setCurrentPage('INC')"
        :disabled="currentPage === numberOfPages"
      >
        Next
      </button>
    </div>
  </div>
</template>
<script>
import {HTTP} from '../../services/account-services.js'
export default {
  name: 'History',
  data() {
    return {
      count: 0, // initial transaction count
      limit: 20, // amount per page
      skip: 0, // page indexer
      numberOfPages: 0,
      currentPage: 1,
      histories: {},
      noHistory: false,
      loading: true
    }
  },
  methods: {
    getTransactionCount() {
      let userId = localStorage.getItem('userId')
      let token = localStorage.getItem('authToken')
      return HTTP.get(`/purchases/${userId}/count?access_token=${token}`)
    },
    setCurrentPage(action) {
      if (action === 'INC') {
        this.skip = this.skip + this.limit
        this.currentPage = this.currentPage + 1
      }
      if (action === 'DEC') {
        this.skip = this.skip - this.limit
        this.currentPage = this.currentPage - 1
      }
      this.getHistory()
    },
    normalizePaymentMethod(paymentMethod) {
      if (!paymentMethod) return
      return paymentMethod.split('_').join(' ')
    },
    // Set payment method only for records where the field
    // `paymentMethod` is missing in the dataset returned by the API
    injectPaymentMethod(records) {
      records.forEach((record) => {
        if (!record.payment.paymentMethod) {
          if (record.payment.phoneNumber) record.payment.paymentMethod = 'mobile_wallet'
          else record.payment.paymentMethod = 'credit_card'
        }
      })
    },
    getHistory() {
      this.loading = true
      let token = localStorage.getItem('authToken')
      let userId = localStorage.getItem('userId')
      let filter = `&filter[limit]=${this.limit}&filter[skip]=${this.skip}&filter[order]=created%20DESC`
      HTTP.get(`/purchases?filter[where][accountId]=${userId}${filter}&access_token=${token}`)
        .then(response => {
          if (response.data.length === 0) {
            this.loading = false
            this.noHistory = true
          } else {
            this.histories = response.data
            this.injectPaymentMethod(this.histories)
            this.loading = false
            this.noHistory = false
            // console.log(response.data)
          }
        }).catch(function(e) {
          console.error(e.message)
        })
    }
  },
  beforeMount() {
    this.getHistory()
    this.getTransactionCount().then((result) => {
      this.count = result.data.count
      this.numberOfPages = Math.ceil(this.count / this.limit)
    })
  }
}
</script>
<style scoped>
.container {
  width: 100%;
}

.faq {
  width: 95%;
  margin: 0 auto;
}

.centerplease {
  text-align:center;
  margin: 0 auto;
  font-size: 40px;
}

.question {
  background: rgba(246, 246, 246, 1);
  color: #666666;
  padding: 10px 10px 10px 50px;
  font-size: 13px;
  text-transform: uppercase;
  cursor: pointer;
  border: 1px solid #d9d9d9;

  display: block;
  font-weight: normal;
  position: relative;
}

.answers {
  border-top: 1px solid #2a4163;
  /* background: #8FBC8F; */
  /* color: #4892c7; */
  padding: 0px 15px;
  margin: 0 0 7px 0;
  height: 0;
  overflow: hidden;
  z-index: 1;
  position: relative;
  opacity: 0;
  -webkit-transition: .7s ease;
  -moz-transition: .7s ease;
  -o-transition: .7s ease;
  transition: .7s ease;
}

.questions:checked ~ .answers{
  height: auto;
  opacity: 1;
  padding: 15px;
}

.plus {
  position: absolute;
  margin-left: 10px;
  margin-top: 7px;
  z-index: 5;
  font-size: 1.8em;
  line-height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-transition: .3s ease;
  -moz-transition: .3s ease;
  -o-transition: .3s ease;
  transition: .3s ease;
}

.questions:checked ~ .plus {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

.questions {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Account/History.vue